import { Component, OnDestroy, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ActivatedRoute, NavigationStart, Router, RouterEvent } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { ErrorService } from './core/services/error/error.service';
import { AppRoute, cookieConsentAllowedRoutes } from './routing/routing.config';
import { BehaviorSubject, delay, Subscription, tap } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit, OnDestroy {
  env = environment;
  title = 'amilearn-portal-presentation';
  routerSub: Subscription;
  showCookieConsentSubject = new BehaviorSubject<boolean>(false);
  showCookieConsent$ = this.showCookieConsentSubject.asObservable();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private logger: NGXLogger,
    private errorService: ErrorService,
  ) {
  }

  ngOnInit(): void {
    this.routerSub = this.router.events.pipe(
      delay(0),
    ).subscribe(async (event: RouterEvent) => {
      if (event instanceof NavigationStart) {
        this.logger.info('[AppComponent] Router event NavigationStart sub. Store event.url in data service - ', event.url);

        // Store prev URL
        const querySignPos = event.url.indexOf('?');
        const appRoute = event.url.substring(0, querySignPos === -1 ? undefined : querySignPos);
        if (!appRoute.includes(AppRoute.ERROR_PAGE) && this.route.snapshot.queryParamMap.get('code') === null) {
          this.logger.info(`[NavigationStart] Saved route - ${event.url}`);
          this.errorService.sharedNavigationUrl = event.url as AppRoute;
        }


        this.showCookieConsentSubject.next(this.shouldShowCookieConsent(appRoute))
      }
    });
  }

  shouldShowCookieConsent(appRoute: string): boolean {
    return cookieConsentAllowedRoutes.some(route => appRoute.includes(route));
  }

  ngOnDestroy(): void {
    this.routerSub.unsubscribe();
  }
}
